import { Link, useParams } from 'react-router-dom';

import useFetch from '../../hooks/useFetch';
import { getContentPage } from '../../services/api';
import RichText from '../../components/RichText';
import Loader from '../../components/Loader';
import ErrorState from '../../components/ErrorState';

/* ------------------------------------------------------------------ */
/* Not-found state                                                       */
/* ------------------------------------------------------------------ */
function PageNotFound() {
  return (
    <main>
      <div className="page-head">
        <div className="page-head-inner">
          <h1>Page Not Found</h1>
          <p>This page doesn't exist or may have been removed.</p>
        </div>
      </div>
      <div className="products-wrap">
        <div className="error-state" style={{ paddingTop: 0 }}>
          <h3>Nothing here</h3>
          <p>The page you're looking for doesn't exist or is no longer available.</p>
          <Link to="/" className="btn-primary" style={{ marginTop: 20, display: 'inline-block' }}>
            Back to Home
          </Link>
        </div>
      </div>
    </main>
  );
}

/* ------------------------------------------------------------------ */
/* Main component                                                        */
/* ------------------------------------------------------------------ */
function ContentPage() {
  const { slug } = useParams();

  const { data: page, loading, error } = useFetch(
    () => getContentPage(slug),
    [slug]
  );

  if (loading) {
    return (
      <main>
        <div className="page-head">
          <div className="page-head-inner">
            <h1>&nbsp;</h1>
          </div>
        </div>
        <div className="products-wrap">
          <Loader />
        </div>
      </main>
    );
  }

  if (error) {
    /* 404 from the API — page doesn't exist or is inactive */
    if (error.response && error.response.status === 404) {
      return <PageNotFound />;
    }

    return (
      <main>
        <div className="page-head">
          <div className="page-head-inner">
            <h1>Error</h1>
          </div>
        </div>
        <div className="products-wrap">
          <ErrorState message="Failed to load this page. Please try again later." />
        </div>
      </main>
    );
  }

  if (!page) {
    return <PageNotFound />;
  }

  return (
    <main>
      {/* PAGE HEAD */}
      <div className="page-head">
        <div className="page-head-inner">
          <p className="label">Nation Wholesale</p>
          <h1>{page.title}</h1>
        </div>
      </div>

      {/* BODY */}
      <div className="products-wrap">
        <div className="section-inner">
          <RichText html={page.body} className="page-content" />
        </div>
      </div>
    </main>
  );
}

export default ContentPage;
